import { createSelector } from 'reselect'

export const getPromoRequest = createSelector(
  state => state && state.ads && state.ads.promoRequest ? state.ads.promoRequest : null,
  promoRequest => promoRequest
)
